export const isPswdValid = (motDePasse) => {
    const isMoreThan12 = motDePasse && motDePasse.length >= 12;
    const isUpperCase = /[A-Z]/.test(motDePasse);
    const isLowerCase = /[a-z]/.test(motDePasse);
    const isNumber = /[0-9]/.test(motDePasse);
    const isSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(motDePasse);
    return isMoreThan12 && isUpperCase && isLowerCase && isNumber && isSpecialChar;
};

export const isPswdIdentique = (motDePasse, motDePasseConfirmation) => {
    return motDePasse === motDePasseConfirmation;
};
